export class LookupFieldKeys {
    static readonly Miscellenious = 1073;
    static readonly National = 1046;
    static readonly Within_the_same_office = 982;
    static readonly National_ID = 1072;
    static readonly Change_of_Term = 1067;
    static readonly CV = 1069;
    static readonly Manama_visa_offer = 2349;
    static readonly Job_description = 1070;
    static readonly Passport_Copy = 1066;
    static readonly Internal_transfer = 717;
    static readonly Internal_Trans_Form = 1068;
    static readonly GosiAddition = "GOSIadditional";
    static readonly Local_Hire = 728;
    static readonly International_Hire = 729;
    static readonly Expat = 1045;

    static readonly Passport = 6024;
    static readonly OfferLetter = 6034;
    static readonly GPN_CV = 6067;
    static readonly GPN_JobDescription = 6079;
    static readonly GPN_Passport_Emp = 6088;
    static readonly GPN_Offer = 6101;
    static readonly GPN_ProfessionalMembership = 6112;
    static readonly GPN_Degree = 9601;
    static readonly GPN_ProfessionalQualification = 9602;
    static readonly GPN_Academic_Cert=12282;
    static readonly GPN_National_ID=6084;
    static readonly GPN_VisaPreApproval=12585;

   
    static readonly  LabourCardorPension_National = 1010;
    static readonly VisaorIqamatransferfromCompanytoCompany=1016;
    static readonly VisaorIqamatransferfromFamilytoCompany=1017;
    static readonly Employmentvisaapplication_outsidecountry=1005;
    
    static readonly YesNo_Yes = 1074;
    static readonly YesNo_No = 1075;
    static readonly NationalityType_Expat = 14570; 
    static readonly WorkLocationDuringTrip_Other = 16207
    static readonly PurposeOfVisit_Other = 16246
    static readonly ProcessingTeam_VisaVendors = 16258; 
    static readonly ProcessingTeam_Others = 16259; 
    static readonly AttestationRequired = 16273;
    static readonly NonMENAPrime = 16326;  

    // Excluded Contract Type IDs
    static readonly EXCLUDED_CONTRACT_TYPE_IDS = [1064, 5907];
    static readonly EXCLUDED_EMP_CATEGORY_IDS = [3105, 12409,12408];

   static readonly EXCLUDED_TRANSFER_TYPE_IDS = [13189];
   static readonly EXCLUDED_TRANSFER_SCENARIO_IDS = [999,1000];

  static readonly EXCLUDED_Immigration_CASETYPE_IDS = [1001,1002,1003,1004,1005,1006,1007,1008,1009,1010,1011,1012,1013,1014,1015,1016,1017,
1018,1019,10800,10801,11050,11051,12021,12022,12025,12026,12210,12211,12266,12267,12268,12269,12270,12271,12320,14420,15068];
  }
